"use strict";

document.addEventListener("DOMContentLoaded", function () {
	// --- small DOM helpers ---

	// Delegated event binding. Calls handler(matchedElement, event).
	function delegate(eventName, selector, handler) {
		document.addEventListener(eventName, function (ev) {
			var el = ev.target.closest(selector);
			if (el) handler(el, ev);
		});
	}

	// Add/remove space-separated class strings (classList.add/remove reject spaces).
	function addClasses(el, str) {
		String(str).split(/\s+/).forEach(function (c) { if (c) el.classList.add(c); });
	}
	function removeClasses(el, str) {
		String(str).split(/\s+/).forEach(function (c) { if (c) el.classList.remove(c); });
	}

	// Type-coerce data-* attribute values (true/false/null/number/JSON).
	function coerce(v) {
		if (v === "true") return true;
		if (v === "false") return false;
		if (v === "null") return null;
		if (v === "") return v;
		if (!isNaN(v) && !isNaN(parseFloat(v))) return +v;
		if (/^[\[{]/.test(v)) {
			try { return JSON.parse(v); } catch (e) { /* fall through */ }
		}
		return v;
	}

	// .data() replacement: a runtime store layered over data-* attributes.
	// dash-case keys (as the original used) map to camelCase dataset keys.
	function dataGet(el, key) {
		if (el._adpData && Object.prototype.hasOwnProperty.call(el._adpData, key)) {
			return el._adpData[key];
		}
		var camel = key.replace(/-([a-z])/g, function (m, c) { return c.toUpperCase(); });
		var raw = el.dataset[camel];
		if (raw === undefined) return undefined;
		return coerce(raw);
	}
	function dataSet(el, key, value) {
		if (!el._adpData) el._adpData = {};
		el._adpData[key] = value;
	}

	// Run an animation once, removing the temp classes when it ends.
	function animateOnce(el, classStr, done) {
		addClasses(el, classStr);
		el.addEventListener("animationend", function handler() {
			el.removeEventListener("animationend", handler);
			removeClasses(el, classStr);
			if (typeof done === "function") done();
		});
	}

	var adpPopup = {};

	(function () {
		var $this;

		adpPopup = {
			sPrevious: window.scrollY,
			sDirection: "down",

			/*
			 * Initialize
			 */
			init: function (e) {
				$this = adpPopup;

				$this.popupInit(e);

				// Init events.
				$this.events(e);
			},

			/*
			 * Events
			 */
			events: function (e) {
				// Custom Events
				delegate("click", ".popup-close", $this.closePopup);
				delegate("click", ".popup-accept", $this.acceptPopup);
				delegate("click", ".popup-accept", $this.closePopup);
				delegate("click", ".age-verification__popup-close", $this.agePopup);
				delegate("click", ".age-verification__popup-close", $this.closePopup);
				delegate("click", ".age-verification__button-no", $this.ageDeclined);

				// Checking this will cause popup to close when user presses key.
				document.addEventListener("keyup", function (e) {
					// Press ESC to Close.
					if (e.key === "Escape") {
						document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(function (popup) {
							$this.closePopup(popup);
						});
					}

					// Press F4 to Close.
					if (e.key === "F4") {
						document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(function (popup) {
							$this.closePopup(popup);
						});
					}
				});

				// Checking this will cause popup to close when user clicks on overlay.
				delegate("click", ".popup-overlay", function (overlay, e) {
					document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach(function (popup) {
						$this.closePopup(popup);
						//$this.closePopup( popup.previousElementSibling );
					});
				});
			},

			/*
			 * Init popup elements
			 */
			popupInit: function (e) {
				// Set scroll direction.
				document.addEventListener("scroll", function () {
					let scrollCurrent = window.scrollY;

					// Set scroll temporary vars.
					if (scrollCurrent > $this.sPrevious) {
						$this.sDirection = "down";
					} else {
						$this.sDirection = "up";
					}

					$this.sPrevious = scrollCurrent;
				});

				// Open popup
				document.querySelectorAll(".popup").forEach(function (popup) {
					// Manual Launch.
					if ("manual" === dataGet(popup, "open-trigger")) {
						let selector = dataGet(popup, "open-manual-selector");

						if (selector) {
							document.querySelectorAll(selector).forEach(function (trigger) {
								trigger.classList.add("popup-trigger");
							});

							delegate("click", selector, function (triggerEl, e) {
								e.preventDefault();

								popup.classList.remove("popup-already-opened");

								$this.openPopup(popup);

								if (triggerEl.classList.contains("popup")) {
									$this.closePopup(selector);
								}
							});
						}
					}

					// Checks whether a popup should be displayed or not.
					if (
						!$this.isAllowPopup(popup) &&
						!popup.classList.contains("age-verification")
					) {
						return;
					}

					$this.openTriggerPopup(popup);
				});
			},

			/*
			 * Trigger open popup
			 */
			openTriggerPopup: function (el) {
				let popup = el;

				var trigger = dataGet(popup, "open-trigger");

				// Age Verification.
				if ("none" === trigger) {
					let ageVerification = $this.getCookie(
						"popup-age-" + dataGet(popup, "id") || 0
					);

					if (!ageVerification) $this.openPopup(popup);
				}

				// Time Delay.
				if ("delay" === trigger) {
					setTimeout(function () {
						$this.openPopup(popup);
					}, dataGet(popup, "open-delay-number") * 1000);
				}

				// Exit Intent.
				if ("exit" === trigger) {
					var showExit = true;
					document.addEventListener("mousemove", function (e) {
						// Get current scroll position
						var scroll =
							window.pageYOffset || document.documentElement.scrollTop;
						if (e.pageY - scroll < 7 && showExit) {
							$this.openPopup(popup);
							showExit = false;
						}
					});
				}

				// Scroll Position.
				if ("scroll" === trigger) {
					var pointScrollType = dataGet(popup, "open-scroll-type");
					var pointScrollPosition = dataGet(popup, "open-scroll-position");

					// Event scroll.
					document.addEventListener("scroll", function () {
						// Type px.
						if ("px" === pointScrollType) {
							if (window.scrollY >= pointScrollPosition) {
								$this.openPopup(popup);
							}
						}

						// Type %.
						if ("%" === pointScrollType) {
							if ($this.getScrollPercent() >= pointScrollPosition) {
								$this.openPopup(popup);
							}
						}
					});
				}

				// Accept Agreement.
				if ("accept" === trigger) {
					let accept = $this.getCookie(
						"popup-accept-" + dataGet(popup, "id") || 0
					);

					if (!accept) {
						$this.openPopup(popup);
					}
				}
			},

			/*
			 * Trigger close popup
			 */
			closeTriggerPopup: function (el) {
				let popup = el;

				var trigger = dataGet(popup, "close-trigger");

				// Time Delay.
				if ("delay" === trigger) {
					setTimeout(function () {
						$this.closePopup(popup);
					}, dataGet(popup, "close-delay-number") * 1000);
				}

				// Scroll Position.
				if ("scroll" === trigger) {
					var pointScrollType = dataGet(popup, "close-scroll-type");
					var pointScrollPosition = dataGet(popup, "close-scroll-position");
					var initScrollPx = dataGet(popup, "init-scroll-px");
					var initScrollPercent = dataGet(popup, "init-scroll-percent");

					// Event scroll.
					document.addEventListener("scroll", function () {
						// Type px.
						if ("px" === pointScrollType) {
							if (
								"up" === $this.sDirection &&
								window.scrollY < initScrollPx - pointScrollPosition
							) {
								$this.closePopup(popup);
							}

							if (
								"down" === $this.sDirection &&
								window.scrollY >= initScrollPx + pointScrollPosition
							) {
								$this.closePopup(popup);
							}
						}

						// Type %.
						if ("%" === pointScrollType) {
							if (
								"up" === $this.sDirection &&
								$this.getScrollPercent() <
									initScrollPercent - pointScrollPosition
							) {
								$this.closePopup(popup);
							}

							if (
								"down" === $this.sDirection &&
								$this.getScrollPercent() >=
									initScrollPercent + pointScrollPosition
							) {
								$this.closePopup(popup);
							}
						}
					});
				}
			},

			/*
			 * Open popup
			 */
			openPopup: function (el) {
				let popup = el;

				// Hide body scroll.
				if (popup.matches('[data-body-scroll-disable="true"]')) {
					document.body.classList.add("popup-scroll-hidden");
				}

				// Set Cookie of Limit display.
				let limit =
					parseInt($this.getCookie("popup-" + dataGet(popup, "id")) || 0) + 1;

				$this.setCookie("popup-" + dataGet(popup, "id"), limit, {
					expires: dataGet(popup, "limit-lifetime"),
				});

				if (popup.classList.contains("popup-open")) {
					return;
				}

				// Check already opened.
				if (popup.classList.contains("popup-already-opened")) {
					return;
				}

				// Display popup.
				popup.classList.add("popup-open");

				// Set current scroll.
				dataSet(popup, "init-scroll-px", window.scrollY);
				dataSet(popup, "init-scroll-percent", $this.getScrollPercent());

				// Open animation.
				let animation = dataGet(popup, "open-animation");

				$this.applyAnimation(popup, animation);

				// Init close trigger.
				$this.closeTriggerPopup(popup);
			},

			/*
			 * Age popup
			 */
			agePopup: function (el) {
				// Get popup container.
				let popup = el.closest(".popup");

				// Set Cookie of Age.
				$this.setCookie("popup-age-" + dataGet(popup, "id"), 1, {
					expires: 360,
				});
			},

			/*
			 * Age declined
			 */

			ageDeclined: function () {
				document.querySelectorAll(".age-verification__question").forEach(function (el) {
					el.classList.remove("show");
				});
				document.querySelectorAll(".age-verification__declined").forEach(function (el) {
					el.classList.add("show");
				});
			},

			/*
			 * Accept popup
			 */
			acceptPopup: function (el) {
				// Get popup container.
				let popup = el.closest(".popup");

				// Set Cookie of Accept.
				$this.setCookie("popup-accept-" + dataGet(popup, "id"), 1, {
					expires: 360,
				});
			},

			/*
			 * Close popup
			 */
			closePopup: function (el) {
				// el may be an element or a selector string (manual-trigger edge case).
				let node = (typeof el === "string") ? document.querySelector(el) : el;
				if (!node) return;

				// Get popup container.
				let popup = node.closest(".popup");
				if (!popup) return;

				// Close animation.
				let animation = dataGet(popup, "exit-animation");

				$this.applyAnimation(popup, animation, function () {
					// Already opened.
					popup.classList.add("popup-already-opened");

					// Hide popup.
					popup.classList.remove("popup-open");
				});
				// Remove classes from body.
				document.body.classList.remove("popup-scroll-hidden");
			},

			/*
			 * Checks whether a popup should be displayed or not
			 */
			isAllowPopup: function (el) {
				let popup = el;

				// Has user seen this popup before?
				let limitDisplay = parseInt(dataGet(popup, "limit-display") || 0);

				let limitDisplayCookie = parseInt(
					$this.getCookie("popup-" + dataGet(popup, "id"))
				);

				if (
					limitDisplay &&
					limitDisplayCookie &&
					limitDisplayCookie >= limitDisplay
				) {
					return;
				}

				return true;
			},

			/*
			 * Apply animation
			 */
			applyAnimation: function (el, name, callback) {
				var popup = el.closest(".popup");
				if (!popup) return;

				var overlayName;
				if (typeof callback === "function") {
					overlayName = "popupExitFade";
				} else {
					overlayName = "popupOpenFade";
				}

				// Overlay Animation.
				var overlay = popup.nextElementSibling;
				if (overlay && overlay.matches(".popup-overlay")) {
					animateOnce(overlay, "popup-animated " + overlayName);
				}

				// Wrap Animation.
				popup.querySelectorAll(".popup-wrap").forEach(function (wrap) {
					// remove the animation classes after animation ends
					// required in order to apply new animation on close
					animateOnce(wrap, "popup-animated " + name, function () {
						if (typeof callback === "function") {
							callback();
						}
					});
				});
			},

			/*
			 * Set cookie
			 */
			getCookie: function (name) {
				var matches = document.cookie.match(
					new RegExp(
						"(?:^|; )" +
							name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
							"=([^;]*)"
					)
				);
				return matches ? decodeURIComponent(matches[1]) : undefined;
			},

			/*
			 * Set cookie
			 */
			setCookie: function (name, value, options) {
				options = options || {};

				options.path = options.hasOwnProperty("path") ? options.path : "/";

				options.expires = parseInt(options.expires);

				if (typeof options.expires == "number" && options.expires) {
					options.expires = new Date().setDate(
						new Date().getDate() + options.expires
					);

					options.expires = new Date(options.expires).toUTCString();
				}

				value = encodeURIComponent(value);

				var updatedCookie = name + "=" + value;

				for (var propName in options) {
					updatedCookie += "; " + propName;
					var propValue = options[propName];
					if (propValue !== true) {
						updatedCookie += "=" + propValue;
					}
				}

				document.cookie = updatedCookie;
			},

			/*
			 * Get scroll percent
			 */
			getScrollPercent: function () {
				var h = document.documentElement,
					b = document.body,
					st = "scrollTop",
					sh = "scrollHeight";
				return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
			},
		};
	})();

	// Initialize.
	adpPopup.init();

	document.addEventListener("shopify:section:load", function () {
		adpPopup.init();
	});

	document.addEventListener("shopify:section:unload", function () {
		document.body.classList.remove("popup-scroll-hidden");
	});
});
